import { Injectable, inject } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as sustainabilitySettingsActions from '../actions/farm-settings.actions';

@Injectable()
export class FarmSettingsResolver {
  private readonly store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve() {
    this.store.dispatch(sustainabilitySettingsActions.loadFarmSettings());
    return of(true);
  }
}
